module.exports = __webpack_public_path__ + "static/story6-social-1200x630-71f5b543228af464e6ea1994cbdbd846.jpg";